import { Icon, Modal } from '@smartgift/frontend-toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ShareViaEmail from './ShareViaEmail';
import SharingType from './SharingType';

function OrderConfirmationModal({
  isModalOpen,
  onModalOpen,
  onSendViaEmail,
  onCreateGiftLink,
  experienceSettings
}) {
  const { t } = useTranslation();
  const [shareStep, setShareStep] = React.useState('default');
  const [isPrimaryButtonDisabled, setPrimaryButtonDisabled] = React.useState(false);
  const [primaryButtonText, setPrimaryButtonText] = React.useState(t('next'));
  const [secondaryButtonText, setSecondaryButtonText] = React.useState(t('cancel'));
  const [selectedShareType, setSelectedShareType] = React.useState('email');
  const [sendEmailSubject, setSendEmailSubject] = React.useState();

  useEffect(() => {
    setSendEmailSubject(
      t('justSentYouAGift', { name: experienceSettings?.messageParams?.senderName })
    );
  }, [experienceSettings]);

  const templates = {
    default: {
      Component: SharingType,
      title: t('orderConfirmed')
    },
    viaEmail: {
      title: t('chooseAnEmailSubjectLine'),
      icon: (
        <Icon
          style={{
            marginRight: '8px',
            cursor: 'pointer'
          }}
          name="left"
          onClick={() => setShareStep('default')}
        />
      ),
      Component: ShareViaEmail
    }
  };

  const template = templates[shareStep];

  return (
    <Modal
      isOpen={isModalOpen}
      title={template.title}
      onRequestClose={onModalOpen}
      primaryButtonProps={{
        children: primaryButtonText,
        onClick: async () => {
          if (selectedShareType === 'email' && shareStep !== 'viaEmail') {
            setShareStep('viaEmail');
          } else if (shareStep === 'viaEmail') {
            await onSendViaEmail(sendEmailSubject);
          } else {
            await onCreateGiftLink();
            onModalOpen(false);
          }
        },
        disabled: isPrimaryButtonDisabled,
        endIcon:
          shareStep === 'default' && selectedShareType === 'email' ? (
            <Icon name="next" size="md" />
          ) : null
      }}
      secondaryButtonProps={{
        children: secondaryButtonText,
        onClick: async () => {
          if (shareStep === 'viaEmail') {
            setShareStep('default');
            setSecondaryButtonText('cancel');
            setPrimaryButtonText('next');
          } else {
            onModalOpen(false);
          }
        }
      }}
      onBack={
        shareStep === 'viaEmail'
          ? () => {
              setShareStep('default');
              setSecondaryButtonText('cancel');
              setPrimaryButtonText('next');
            }
          : null
      }
    >
      <template.Component
        setPrimaryButtonDisabled={setPrimaryButtonDisabled}
        setPrimaryButtonText={setPrimaryButtonText}
        setSecondaryButtonText={setSecondaryButtonText}
        setSelectedShareType={setSelectedShareType}
        selectedShareType={selectedShareType}
        sendEmailSubject={sendEmailSubject}
        setSendEmailSubject={setSendEmailSubject}
        experienceSettings={experienceSettings}
      />
    </Modal>
  );
}

export { OrderConfirmationModal };
